import { SocialShare } from "@quintype/components";
import React from "react";
import { object } from "prop-types";

import { SocialShareTemplate } from "./social-share-template";

const StoryMetaIcons = ({ story }) => {
  return <SocialShare template={SocialShareTemplate} title={story.headline} fullUrl={encodeURI(story.url)} />;
};

StoryMetaIcons.propTypes = {
  story: object,
};

export default StoryMetaIcons;
